import { Action } from '@ngrx/store';

export class AdvancedPlatformsActions implements Action {
  public static getPlatforms: string = '[PLATFORMS] GET_PLATFORMS';
  public static getPlatformsError: string = '[PLATFORMS] GET_PLATFORMS_ERROR';
  public static getPlatformsSuccess: string =
    '[PLATFORMS] GET_PLATFORMS_SUCCESS';

  public static getSubscribes: string = '[PLATFORMS] GET_SUBSCRIBES';
  public static getSubscribesError: string = '[PLATFORMS] GET_SUBSCRIBES_ERROR';
  public static getSubscribesSuccess: string =
    '[PLATFORMS] GET_SUBSCRIBES_SUCCESS';

  public static getClientsTradedOperationsCount: string =
    '[PLATFORMS] GET_CLIENTS_TRADED_OPERATIONS_COUNT';
  public static getClientsTradedOperationsCountError: string =
    '[PLATFORMS] GET_CLIENTS_TRADED_OPERATIONS_COUNT_ERROR';
  public static getClientsTradedOperationsCountSuccess: string =
    '[PLATFORMS] GET_CLIENTS_TRADED_OPERATIONS_COUNT_SUCCESS';

  public static setSubscribe: string = '[PLATFORMS] SET_SUBSCRIBE';
  public static setSubscribeError: string = '[PLATFORMS] SET_SUBSCRIBE_ERROR';
  public static setSubscribeSuccess: string =
    '[PLATFORMS] SET_SUBSCRIBE_SUCCESS';

  public static setUnsubscribe: string = '[PLATFORMS] SET_UNSUBSCRIBE';
  public static setUnsubscribeError: string =
    '[PLATFORMS] SET_UNSUBSCRIBE_ERROR';
  public static setUnsubscribeSuccess: string =
    '[PLATFORMS] SET_UNSUBSCRIBE_SUCCESS';

  public static resetBuyPlatform: string = '[PLATFORMS] RESET_BY_PLATFORM';
  public static resetSetSubscribeError: string =
    '[PLATFORMS] RESET_SET_SUBSCRIBE_ERROR';

  constructor(public type: string, public payload?: any) {}
}
